
















import { useTranslate } from '@front-app/hooks/useTranslate';
import {
	computed,
	defineComponent,
	Ref,
	watch,
} from '@vue/composition-api';
import { Region } from 'country-region-data';
import { CODE_TO_COUNTRY, EMPTY_REGION } from './CountryPickerData';
import SelectBox from './SelectBox.vue';
import { SelectBoxChoice } from './SelectBoxModel';

export default defineComponent({
	components: { SelectBox },
	props: {
		countryCode: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			default: '',
		},
		allowNoneOption: Boolean,
	},
	setup(props, ctx) {
		const $t = useTranslate(ctx);
		watch(() => props.countryCode, (curr, prev) => {
			if (prev !== curr) {
				if (props.allowNoneOption) {
					ctx.emit('input', EMPTY_REGION);
				} else {
					ctx.emit('input', CODE_TO_COUNTRY[props.countryCode].regions[0].shortCode);
				}
			}
		}, { immediate: true });
		const regionOptions: Ref<SelectBoxChoice[]> = computed(() => {
			const baseOptions = CODE_TO_COUNTRY[props.countryCode]
				.regions
				.map(({ name, shortCode }) => ({
					key: shortCode,
					label: name,
				}));
			if (props.allowNoneOption) {
				const val: SelectBoxChoice = {
					key: EMPTY_REGION,
					label: $t('none') as unknown as string,
				};
				return [val].concat(baseOptions);
			}
			return baseOptions;
		});
		const regionByShortcode = computed(() => CODE_TO_COUNTRY[props.countryCode]
			.regions
			.reduce((acc: Record<string, Region>, curr) => {
				acc[curr.shortCode] = curr;
				return acc;
			}, {}));
		const computedRegion = computed(() => {
			if (props.allowNoneOption && props.value === EMPTY_REGION) {
				return $t('none') as unknown as string;
			}
			if (props.value && CODE_TO_COUNTRY[props.countryCode]) {
				return regionByShortcode.value[props.value].name;
			}
			const code = CODE_TO_COUNTRY[props.countryCode].regions[0].shortCode;
			return regionByShortcode.value[code].name;
		});
		return {
			computedRegion,
			regionOptions,
			regionByShortcode,
		};
	},
});
